import { useParams } from "react-router";
import { DocumentationCard } from "@/services/backend/rlt/work-orders/components/documentation-card";

export function WorkOrderExecutionDocumentationRoute() {
  const { workOrderId, documentationId } = useParams();
  return (
    <DocumentationCard
      documentationId={documentationId!}
      workOrderId={workOrderId!}
    />
  );
}
